import React, { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const BASE_URL = 'https://mv-tyre.demo-customproject.com/backend';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const getCsrfToken = async () => {
    const res = await fetch(`${BASE_URL}/csrf-token`, {
      credentials: 'include',
    });
    const data = await res.json();
    return data.csrfToken;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      toast.error('Email is required');
      return;
    }

    if (!validateEmail(email)) {
      toast.error('Please enter a valid email');
      return;
    }

    setIsSubmitting(true);
    try {
      const csrfToken = await getCsrfToken();

      const res = await fetch(`${BASE_URL}/user/forgot-submit`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': csrfToken,
        },
        body: JSON.stringify({ email }),
      });

      const result = await res.json();

      if (res.ok && result.status) {
        toast.success(result.message || 'Reset link sent successfully');
        setEmail('');
      } else {
        toast.error(result.message || 'Something went wrong');
      }
    } catch (err) {
      console.error(err);
      toast.error('An error occurred while sending reset link');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <section className="inner-banner">
        <div className="container-fluid web-padding">
          <div className="row">
            <div className="col-md-6" data-aos="flip-left" data-aos-duration={2000}>
              <div className="inner-banner-left">
                <h1>Forgot Password</h1>
              </div>
            </div>
            <div className="col-md-6">
              <div className="inner-banner-right">
                <img src="/images/hero-tires.png" alt="img" />
              </div>
            </div>
          </div>
        </div>
        <h2>Tyres</h2>
      </section>

      <section>
        <div className="login-sec">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-6 col-md-8 col-12">
                <div className="login-box wow fadeInUp" data-wow-duration="2s">
                  <form onSubmit={handleSubmit}>
                    <h2>Send Reset Password Link</h2>
                    <div className="col-lg-12">
                      <input
                        type="email"
                        name="email"
                        placeholder="Enter your email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                    <button type="submit" className="theme-btn-1" disabled={isSubmitting}>
                      {isSubmitting ? 'Sending...' : 'Send Reset Password Link'}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
};

export default ForgotPassword;
